/**
 * Submits a form POST request by dynamically creating and submitting a form
 * This is commonly used for B2B punchout flows where XML data needs to be POSTed
 * 
 * @param {string} formPostUrl - The URL to submit the form to
 * @param {string} orderMessage - The order message (typically XML) to submit
 * @param {string} target - The form target (_self, _blank, _parent, etc.)
 * @param {{ cleanupDelayMs?: number }} options - Optional cleanup config; when provided, removes the form after the specified delay
 * @returns {{ form: HTMLFormElement, cleanupTimerId: number | null }}
 */
export const submitFormPost = (
  formPostUrl,
  orderMessage,
  target = '_self',
  options = {}
) => {
  const { cleanupDelayMs } = options

  // Create a hidden form
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = formPostUrl
  form.target = target
  form.style.display = 'none'

  // Create a hidden input for the order message
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = 'cxml-urlencoded' // Standard field name for cXML messages
  input.value = orderMessage

  // Append input to form
  form.appendChild(input)

  // Append form to body and submit
  document.body.appendChild(form)
  form.submit()

  let cleanupTimerId = null

  if (typeof cleanupDelayMs === 'number' && cleanupDelayMs >= 0) {
    cleanupTimerId = setTimeout(() => {
      if (document.body.contains(form)) {
        document.body.removeChild(form)
      }
    }, cleanupDelayMs)
  }

  return {
    form,
    cleanupTimerId,
  }
}

export default submitFormPost
